import { Link } from 'react-router-dom';
import IndexMark from '@/components/index/IndexMark';
import { FOOTER_COLUMNS } from '@/config/marketingContent';

type MarketingFooterProps = {
  slim?: boolean;
};

export default function MarketingFooter({ slim = false }: MarketingFooterProps) {
  if (slim) {
    return (
      <footer className="border-t border-[#2a2a2a] bg-[#0a0a0a] px-4 py-4 text-[10px] font-mono uppercase tracking-wider text-white/35 flex flex-wrap gap-4 justify-between">
        <IndexMark compact />
        <span>SOC 2 · TLS 1.3 · Encrypted at rest</span>
        <Link to="/enterprise" className="hover:text-white/60">
          Enterprise
        </Link>
      </footer>
    );
  }

  return (
    <footer className="border-t border-[#2a2a2a] bg-[#0a0a0a]">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-10">
          <IndexMark />
          <div className="flex flex-wrap gap-1.5 text-[10px] font-mono uppercase text-white/30">
            <span className="border border-[#2a2a2a] px-2 py-1">SOC 2 Type II</span>
            <span className="border border-[#2a2a2a] px-2 py-1">TLS 1.3</span>
            <span className="border border-[#2a2a2a] px-2 py-1">AES-256</span>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {(
            [
              ['Product', FOOTER_COLUMNS.product],
              ['Methodology', FOOTER_COLUMNS.methodology],
              ['Security', FOOTER_COLUMNS.security],
              ['Legal', FOOTER_COLUMNS.legal],
            ] as const
          ).map(([title, links]) => (
            <div key={title}>
              <p className="ni-label mb-3">{title}</p>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-sm text-white/45 hover:text-white font-sans transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-white/45 hover:text-white font-sans transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-10 text-[10px] font-mono text-white/25">
          © {new Date().getFullYear()} Nuclius Index · Forensic screenplay intelligence
        </p>
      </div>
    </footer>
  );
}
